// extracted by mini-css-extract-plugin
export default {"board":"Board_board__6Ufhw"};